import React from "react";

export default function TripIcon2() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 21L14 3M20.5 21L10 3M15.5 21L12 15L8.5 21M2 21H22"
        stroke="#71717A"
        strokeWidth={1.5}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
